import { PROCESS } from "@/lib/content";

export default function Process() {
  return (
    <section id="folyamat" data-testid="process-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-violet-600 font-bold mb-4">[ 03 ] · Folyamat</div>
          <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl leading-[0.95] max-w-3xl">
            4 lépés a biztonságos<br />
            <span className="text-gray-400">újraindulásig.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-gray-100/10">
          {PROCESS.map((p, i) => (
            <div
              key={p.step}
              data-testid={`process-step-${i + 1}`}
              className="bg-[#F0F1F5] p-8 md:p-10 relative group hover:bg-white transition-colors duration-300"
            >
              <div className="font-display font-black text-7xl md:text-8xl text-transparent bg-gradient-to-br from-blue-500/30 to-violet-500/10 bg-clip-text leading-none">
                {p.step}
              </div>
              <h3 className="font-display text-xl font-bold uppercase tracking-tight text-gray-900 mt-4">{p.title}</h3>
              <p className="text-sm text-gray-500 mt-2 leading-relaxed">{p.desc}</p>
              {i < PROCESS.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-3 w-6 h-px bg-gradient-to-r from-violet-500/50 to-transparent" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
